(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["detailed-product-view"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

    function canScrollInline(scroller) {
      return scroller.scrollWidth > scroller.clientWidth + 1;
    }

    function clampScroll(value, max) {
      return Math.max(0, Math.min(value, max));
    }

    function initializeDetailedProductScroller(scroller) {
      if (scroller.dataset.detailedProductScrollerInitialized === 'true') return;

      scroller.dataset.detailedProductScrollerInitialized = 'true';

      let isDragging = false;
      let hasDragged = false;
      let startX = 0;
      let startScrollLeft = 0;
      let wheelTarget = scroller.scrollLeft;
      let wheelAnimationFrame = 0;
      let snapTimeout = 0;

      function stopWheelAnimation() {
        if (!wheelAnimationFrame) return;

        cancelAnimationFrame(wheelAnimationFrame);
        wheelAnimationFrame = 0;
      }

      function clearSnapTimeout() {
        if (!snapTimeout) return;

        clearTimeout(snapTimeout);
        snapTimeout = 0;
      }

      function getNearestSnapLeft() {
        const cards = Array.from(scroller.querySelectorAll('.detailed-product-view__card'));
        const scrollerLeft = scroller.getBoundingClientRect().left;
        const currentScrollLeft = scroller.scrollLeft;
        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

        return cards.reduce((nearest, card) => {
          const cardLeft = card.getBoundingClientRect().left - scrollerLeft + currentScrollLeft;
          const clampedCardLeft = clampScroll(cardLeft, maxScrollLeft);

          return Math.abs(clampedCardLeft - currentScrollLeft) < Math.abs(nearest - currentScrollLeft)
            ? clampedCardLeft
            : nearest;
        }, currentScrollLeft);
      }

      function snapToNearestCard() {
        if (!desktopMediaQuery.matches || !canScrollInline(scroller)) return;

        stopWheelAnimation();
        wheelTarget = getNearestSnapLeft();
        scroller.scrollTo({ left: wheelTarget, behavior: 'smooth' });
      }

      function scheduleSnap() {
        clearSnapTimeout();
        snapTimeout = setTimeout(snapToNearestCard, 180);
      }

      function animateWheelScroll() {
        const distance = wheelTarget - scroller.scrollLeft;

        if (Math.abs(distance) < 0.5) {
          scroller.scrollLeft = wheelTarget;
          wheelAnimationFrame = 0;
          return;
        }

        scroller.scrollLeft += distance * 0.18;
        wheelAnimationFrame = requestAnimationFrame(animateWheelScroll);
      }

      scroller.addEventListener(
        'wheel',
        (event) => {
          if (!desktopMediaQuery.matches || !canScrollInline(scroller)) return;

          const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
          const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          const currentTarget = wheelAnimationFrame ? wheelTarget : scroller.scrollLeft;
          const nextScrollLeft = clampScroll(currentTarget + delta, maxScrollLeft);

          if (nextScrollLeft === currentTarget) return;

          event.preventDefault();
          wheelTarget = nextScrollLeft;
          scheduleSnap();

          if (!wheelAnimationFrame) {
            wheelAnimationFrame = requestAnimationFrame(animateWheelScroll);
          }
        },
        { passive: false }
      );

      scroller.addEventListener('pointerdown', (event) => {
        if (
          !desktopMediaQuery.matches ||
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          !canScrollInline(scroller)
        ) {
          return;
        }

        event.preventDefault();
        stopWheelAnimation();
        clearSnapTimeout();
        isDragging = true;
        hasDragged = false;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!isDragging) return;

        event.preventDefault();
        const distance = event.clientX - startX;
        hasDragged = hasDragged || Math.abs(distance) > 3;
        scroller.scrollLeft = startScrollLeft - distance;
        wheelTarget = scroller.scrollLeft;
      });

      scroller.addEventListener('dragstart', (event) => event.preventDefault());

      function endDrag(event) {
        if (!isDragging) return;

        isDragging = false;
        scroller.classList.remove('is-dragging');
        snapToNearestCard();

        if (scroller.hasPointerCapture(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }
      }

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener(
        'click',
        (event) => {
          if (!hasDragged) return;

          event.preventDefault();
          event.stopPropagation();
          hasDragged = false;
        },
        true
      );
    }

    function initializeDetailedProductScrollers() {
      document.querySelectorAll('.detailed-product-view__scroller').forEach(initializeDetailedProductScroller);
    }

    initializeDetailedProductScrollers();
    document.addEventListener('shopify:section:load', initializeDetailedProductScrollers);
  })();
  } catch(e) { console.error(e); }
})();

})();
